import { createSortOption } from "@nosto/preact"
export const sizes = [48, 96, 144]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "_score", order: "desc" }),
    createSortOption("-price", "Price, high to low", { field: "price", order: "desc" }),
    createSortOption("price", "Price, low to high", { field: "price", order: "asc" }),
    createSortOption("date", "Date, old to new", { field: "datePublished", order: "asc" }),
    createSortOption("-date", "Date, new to old", { field: "datePublished", order: "desc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}

export const brandsWithPlps = [
    { title: 'Americain', url: '/collections/americain' },
    { title: 'Brixton', url: '/collections/brixton' },
    { title: 'Calvin Klein', url: '/collections/calvin-klein' },
    { title: 'Inventory', url: '/collections/inventory' },
    { title: 'Kiss Chacey', url: '/collections/kiss-chacey' },
    { title: 'Lee Jeans', url: '/collections/lee-jeans' },
    { title: 'Nena and Pasadena', url: '/collections/nena-and-pasadena' },
    { title: 'New Era', url: '/collections/new-era' },
    { title: 'Nixon', url: '/collections/nixon' },
    { title: 'Nomadic Paradise', url: '/collections/nomadic-paradise' },
    { title: 'Pyra', url: '/collections/pyra' },
    { title: 'Thrills', url: '/collections/thrills' },
    { title: 'WNDRR', url: '/collections/wndrr' },
    { title: 'Wrangler', url: '/collections/wrangler' },
    { title: 'XLarge', url: '/collections/xlarge' },
]